<div class="fs-xs fw-bold">
  <ng-content select="[title]"></ng-content>
</div>

<div class="fs-xs m-0h-t" style="white-space: pre-line">
  <ng-content></ng-content>
</div>

<div class="fl fl-ai-c fl-jc-fs" [class.m-1-t]="showGotIt || showFooter">
  <button
    class="fs-xs underline"
    [style.display]="showFooter ? 'block' : 'none'"
    (mousedown)="$event.preventDefault()"
    (click)="footerClicked$.emit(); $event.stopPropagation()"
    >
    <ng-content select="[footer]"></ng-content>
  </button>

	<div class="h-0 fl-adaptable"></div>

	@if (showGotIt) {
		<button
			uiNewButtonOutline
			variant="WHITE"
			size="SMALL"
			(mousedown)="$event.preventDefault()"
			(click)="markAsSeen(); $event.stopPropagation()"
		>
			Got It
		</button>
	}
</div>
